module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt3_jp.b8c86fca131cca0d717a6b33792e75c1.png";